/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Value/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import InputSmall from 'DesignSystem/InputSmall/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Value({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentPaymentPlans/Configuration/DefaultPaymentPlans/AddRuleset/DefaultPaymentPlans/Content/DefaultPaymentPlan/Discounts/Discount/Value",
  onChange
  
}) {
let discountValueValueData = fromData.useDataValue({ viewPath,
context: 'discount',
path: 'value',
})
let discountValueChangeData = fromData.useDataChange({ viewPath,
context: 'discount',
path: 'value',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<InputSmall
  viewPath={`${viewPath}/InputSmall`}
 label={false}
 type="number"
 data="discount.value"
 onChange={discountValueChangeData}
 value={discountValueValueData}
 width={140}
 marginRight={dtSpaceXxs}
/>
{children}
</React.Fragment>)
}